import React from "react"

const Seo = <>SEO</>

export default Seo
